import { Router } from '@angular/router';
import { DataService } from './data.service';
import { Injectable } from '@angular/core';

@Injectable()
export class NavigationService {
  constructor(
    private _dataService: DataService,
    private _router: Router,
  ) { }

  navigate(route: string, force: boolean = true) {
    if (force) {
      this._dataService.forceNavigation = true;
    }

    this._router.navigate([route]);
  }
}
